import { render, staticRenderFns } from "./perfectInfo.vue?vue&type=template&id=6149756d&scoped=true"
import script from "./perfectInfo.vue?vue&type=script&lang=js"
export * from "./perfectInfo.vue?vue&type=script&lang=js"
import style0 from "./perfectInfo.vue?vue&type=style&index=0&id=6149756d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6149756d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6149756d')) {
      api.createRecord('6149756d', component.options)
    } else {
      api.reload('6149756d', component.options)
    }
    module.hot.accept("./perfectInfo.vue?vue&type=template&id=6149756d&scoped=true", function () {
      api.rerender('6149756d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/perfectInfo.vue"
export default component.exports